import React from 'react';
import { useTranslation } from 'react-i18next';

const Terms: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-8">{t('terms.title')}</h1>
        <p className="text-gray-700">{t('terms.comingSoon')}</p>
      </div>
    </div>
  );
};

export default Terms;
